export const MERCHANT_NAME_CONSTANT = "Boingo";
